<template>
  <div id="mapIndex">
    <!-- 校企列表弹窗 -->
    <el-dialog title="校企列表" class="list_dialog" :visible.sync="dialogVisible" width="480px" >
      <div style="height:393px;overflow-y:aoto;">

        <div v-for="(item,index) in getCustomerListA" :key="index">
          <div class="dialogTop" :class="item.selTrue==1?'dialogSel':''" @click="schoolList(item.id,'father')">{{item.label}}<div v-if="item.alarmTrue==1" class="Divbadge" value=" "></div></div>
          <ul class="dialogTop_li">
            <li v-for="(item1,index) in item.children" :class="item1.selTrue==1?'dialogSel':''" @click="schoolList(item1.id,'Son')" :key="index">{{item1.label}}<div v-if="item1.alarmTrue==1" class="Divbadge" value=" "></div></li>
            <!-- <li>西乡外国语<div v-if="true" class="Divbadge" value=" "></div></li> -->
          </ul>
        </div>
      </div>
    </el-dialog>
    <el-header>
        <top-Nav></top-Nav>
    </el-header>
    <div class="mainHead">
        <div class="route">
            <span class="crumbs"></span><span>监控中心</span>
        </div>
        <div  class="btnsW"> 
            <ul class="btns">
                <li :class="{'btn_select1': !btnS}"  >地图</li>
                <li :class="{'btn_select1': btnS}"  @click="mapBtn()">列表</li>
            </ul>
        </div>
        <div class="switchBtn"  @click="openDialog()">切换校企</div>
    </div>



    <div class="screen_container">

      

      <!-- <marquee class="marqueeS">
        <p class='alarmScroll_W'><span class='alarmScroll_color'></span><span>紫光信息港</span></p>
      </marquee> -->
      




      <!--<swiper :options="mapSwiperOption" ref="myMapSwiper">-->
        <!--<swiper-slide><div id="map_container"></div></swiper-slide>-->
        <!--<swiper-slide><div id="map_container1">22222</div></swiper-slide>-->
      <!--</swiper>-->
      <div id="map_container"  :class="{'disabledNone':showMap == 2}"></div>
      <div id="map_container1" :class="{'disabledNone':showMap == 1}"><homeConstruction ref="mapHome"></homeConstruction></div>
      <!-- <el-carousel indicator-position="none" class="swiper-container" height="100%" :interval="30000" :autoplay="false" @change="getBuildingId" arrow="never">
        <el-carousel-item v-for="(item,index) in showType" :key="index">
          
        </el-carousel-item>
      </el-carousel> -->
    </div>




     <!-- <div class="title">
        <span class="title_info">智慧消防监测预警管理系统</span>
        <span class="now_time">{{nowTime}}</span>
      </!--> -->
      <!--中心容器-->
      <div class="center_container" :style="{width: containerWidth+'px'}" style="margin-top:-5px;">
        <div class="list_item" :style="{width:basicWidth+'px',marginLeft:basicLeft+'px'}">
          <p>安全运行天数</p>
          <p>{{topTotalInfo.safeDays}}/{{topTotalInfo.operationDays}}</p>
        </div>
        <div class="list_item" :style="{width:basicWidth+'px',marginLeft:basicLeft+'px'}">
          <p>历史警告次数</p>
          <p>{{topTotalInfo.historyAlarmCount}}</p>
        </div>
        <div class="list_item" :style="{width:basicWidth+'px',marginLeft:basicLeft+'px'}">
          <p>{{isSchoolCompany}}</p>
          <p v-if="isSchoolCompany =='单位总数'">{{topTotalInfo.customerCount}}</p>
          <p v-else>{{topTotalInfo.monitorCount}}</p>
        </div>
        <div class="list_item" :style="{width:basicWidth+'px',marginLeft:basicLeft+'px'}">
          <p>设备完好率</p>
          <p>{{topTotalInfo.monitorAvailable}}%</p>
        </div>
      </div>
      <!--标记信息-->
      <div class="dot_tip" :style="{left: tipLeft+'px',top:tipTop+'px'}" v-show="isMouseIcon">
        <div class="name_type">
          <span>{{tipHeadInfo.schoolName}}</span>
          <span class="person_info">{{tipHeadInfo.userName}} {{tipHeadInfo.userPhone}}</span>
        </div>
        <div v-for="(item,index) in tipData" :key="index">
          <div class="normal_item" v-if="item.type==1">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_electric.png" alt="">
                </i>
                <span class="icon_name">电气</span>
              </span>
              <span class="item_name">{{item.typeNumber}}</span>
              <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>

                  </marquee>
              </span>
            </div>
          </div>
          <!--水压-->
          <div class="normal_item" v-if="item.type==2">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_water.png" alt="">
                </i>
                <span class="icon_name">水压</span>
              </span>
              <span class="item_name">{{item.typeNumber}}</span>
             <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>

                  </marquee>
              </span>
            </div>
          </div>
          <!--液位-->
          <div class="normal_item" v-if="item.type==3">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_level.png" alt="">
                </i>
                <span class="icon_name">液位</span>
              </span>

              <span class="item_name">{{item.typeNumber}}</span>
             <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>

                  </marquee>
              </span>
            </div>
          </div>
          <!--可燃气-->
          <div class="normal_item" v-if="item.type==4">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_gas.png" alt="">
                </i>
                <span class="icon_name">可燃气</span>
              </span>

              <span class="item_name">{{item.typeNumber}}</span>
             <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>

                  </marquee>
              </span>
            </div>
          </div>
          <!--烟感-->
          <div class="normal_item" v-if="item.type==5">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_smoke.png" alt="">
                </i>
                <span class="icon_name">烟感</span>
              </span>

              <span class="item_name">{{item.typeNumber}}</span>
              <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>

                  </marquee>
              </span>
            </div>
          </div>
          <!--灭火器-->
          <div class="normal_item" v-if="item.type==6">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_bottol.png" alt="">
                </i>
                <span class="icon_name">灭火器</span>
              </span>
              <span class="item_name">{{item.typeNumber}}</span>
             <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fad860">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>

                  </marquee>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="left_content">
        <left ref="mapLeft"></left>
      </div>
      <div class="right_content">
        <right ref="mapRight"></right>
        <div class="right_info">
          <div v-if="topTotalInfo.alarmCount==0&&topTotalInfo.faultCount==0&&topTotalInfo.connectCount==0&&topTotalInfo.normalCount==0" class="No"  >
              <img style="margin: 0;" src="../../../static/img/Nodata.png">
              <span style="color:#fff;">暂无数据</span>
          </div>
          <div v-else>

          
            <div class="right_route">
                <span class="right_crumbs" style="background:#d7504b;"></span><span>告警：{{topTotalInfo.alarmCount}}个</span>
            </div>
            <div class="right_route">
                <span class="right_crumbs" style="background:#fe8463;"></span><span>故障：{{topTotalInfo.faultCount}}个</span>
            </div>
            <div class="right_route">
                <span class="right_crumbs" style="background:#607d8b;"></span><span>离线：{{topTotalInfo.connectCount}}个</span>
            </div>
            <div class="right_route">
                <span class="right_crumbs" style="background:#26c0c0;"></span><span>正常：{{topTotalInfo.normalCount}}个</span>
            </div>
          </div>
        </div>
      </div>
     
  </div>
</template>


<script>


  var map,copyMap;
  import topNav from '../../components/TopNav';
  import left from '@/page/home/mapLeft'//左侧栏
  import right from '@/page/home/mapRight'//右侧栏
  import homeConstruction from '@/components/homeConstruction/index.vue'//建筑图组件
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import {ajaxFuncJson,SocketUrl} from '@/api/ajax';
  export  default {
    components:{
      left,
      right,
      swiper,
      swiperSlide,
      homeConstruction,
      topNav,
    },
    data(){
      return{
         btnS: false,
         showMap:1,//显示地图与建筑1为地图  2为建筑
        showType:[{
          type:1,    //地图
        }],
        flag:false,
        tipData:[],
        dialogVisible: false,//校企列表弹窗
        dialogBuildList: [],//弹窗内建筑列表信息
        radio1: -1,
        mapSwiperOption:{
          // slidesPerView: 1,
          // spaceBetween: 10,
          // loop:true,
          // autoplay:true,
        },
         swiperOption1: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        swiperOption2: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        swiperOption3: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        swiperOption4: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        swiperOption5: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        swiperOption6: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        windowResize:null,
        basicWidth:0,
        basicLeft:0,
        containerWidth:0,
        infoWindow:null,   //定义信息窗口
        topTotalInfo:{},
        nowTime:'',
        clearTime:null,   //定时器
        schoolDeviceInfo:{     //学校设备信息

        },
        tipLeft:0,    //定位left值
        tipTop:0,    //定位top值
        isMouseIcon:false,   //是否移入icon点
        tipHeadInfo:{    //头部信息
          schoolName:'',
          userName: '',
          userPhone: '',
        },
        bodyWidth:0,
        bodyHeight:0,
        getCustomerListA:[],//最终渲染的弹层列表
        getCustomerListAs:[],//弹层列表
        socketNotic:null,//websocket对象

        socketNoticClose :1,//我关闭的

        socketNoticid:'',//websocket需要传的ID
        isSchoolCompany:'单位总数',
        lockReconnect: false,//是否真正建立连接
        timeoutnum: null,//断开 重连倒计时
        timeoutnumSucc: null,//断开 重连倒计时
        timeoutnumSucc1: null,//断开 重连倒计时

      }
    },
    computed: {
      swiperLider0() {
        return this.$refs.myCenterSwiper1[0].swiper
      },
      swiperLider1() {
        return this.$refs.myCenterSwiper2[0].swiper
      },
      swiperLider2() {
        return this.$refs.myCenterSwiper3[0].swiper
      },
      swiperLider3() {
        return this.$refs.myCenterSwiper4[0].swiper
      },
      swiperLider4() {
        return this.$refs.myCenterSwiper5[0].swiper
      },
      swiperLider5() {
        return this.$refs.myCenterSwiper6[0].swiper
      },
    },
    updated(){
      // this.swiperLider.init();
    },
    created(){
        sessionStorage.setItem('buildId','')
        this.getBigScreenData('');
        this.getNowTime();
        this.getMapPosition(); //获取地图上面的点标记
        // this.ajaxShowRed(); //校企列表
        this.getLeftBuildingMap(); //校企列表
        
    },
    mounted(){
      let _this=this;
      map = new AMap.Map('map_container',{
        // zoom: 10,  //设置地图显示的缩放级别
        // center: [116.397428, 39.90923],//设置地图中心点坐标
        // layers: [new AMap.TileLayer.Satellite()],  //设置图层,可设置成包含一个或多个图层的数组
        mapStyle: 'amap://styles/darkblue',  //设置地图的显示样式 自定义地图样式amap://styles/地图样式id
        viewMode: '2D',  //设置地图模式
        lang:'zh_cn',  //设置地图语言类型
      });
      map.setZoom(12);

      let that = this;
      that.windowResize=function () {
        that.containerWidth=$('body').width()-360*2-20*2;
        that.basicWidth=($('body').width()-360*2-20*2)/29*6;
        that.basicLeft=($('body').width()-360*2-20*2)/29;
        that.bodyWidth=$('body').width();
        that.bodyHeight=$('body').height();
      };
      that.windowResize();
      window.addEventListener('resize',that.windowResize);
    },
    methods:{

      mapBtn() {
        sessionStorage.setItem('router','MonitoringSupervise')
        this.$router.push({path:'/content/MonitoringSupervise'})
      },
      //校企列表弹窗
      openDialog(){
        // console.log(this.$refs.spanScroll.offsetWidth)
        
          this.dialogVisible=true;
      },
      //弹窗列表客户伸缩按钮点击
      handle(item) {
          if(item.active == true) {
              item.active = false;
          } else {
              item.active = true;
          }
      },
      // 建筑列表
      ajaxShowRed(){
          ajaxFuncJson('/basicData/getShowRedBuildIdList',{pageType:0,customerId:sessionStorage.getItem('customerId')}).then(res=>{
            if(res.data.status == 200){
              this.redArray = res.data.data; //存储圆点
              this.dialogBuildList.map( k => {
                k.children.map(e => {
                  res.data.data.map( i => {
                    if (e.id == i) {
                      this.redArray.push(k.id)
                    }
                  })
                })
              })
              if (this.redArray.findIndex( e => e == this.custId) > -1) {
                this.isShowTip=true;
              } else {
                this.isShowTip=false;
              }
              if(res.data.data.length != 0){
                this.showBadge = true;  
              }

             
            }
          })
      },
      //校企标注弹窗列表
      getLeftBuildingMap() { 
        let params = {
          customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
            buildingName: '',
            target: 1,
        }
        ajaxFuncJson('/basicData/getCustomerList',params).then(res=>{

          if(res.data.status == 200){
            res.data.data[0].active = false; //12-26X
            
            res.data.data.forEach((item,index)=>{
              item.selTrue = 1;
              item.alarmTrue = 0;
              item.children.forEach((item1,index)=>{
                item1.selTrue = 0;
                item1.alarmTrue = 0;
              })
            })
            this.getCustomerListA = res.data.data ;//获取标记点
            this.socketNoticid = this.getCustomerListA[0].id;//保存当前ID

            // this.websockeInit(this.getCustomerListA[0].id);//连接websocket
            this.getAlarmList()
          }
        })
      },

      //校企标注弹窗列表
      getAlarmList() { 
        let params = {
            pageType: 0,
        }
        ajaxFuncJson('/basicData/getAlarmList',params).then(res=>{
          if(res.data.status == 200){
            this.getCustomerListA.forEach((item,index)=>{
              if(res.data.data.length>0){
                item.alarmTrue = 1;
                item.children.forEach((item1,index)=>{
                  res.data.data.forEach((item2,index)=>{
                    if(item1.id == item2){
                        item1.alarmTrue = 1;
                    }
                  })
                  
                })
              }
            })
            // console.log(this.getCustomerListA)
          }
        })
      },


      
      // 点击校企列表
      schoolList(obi,obj1){
        if(obj1=='Son'){
          this.isSchoolCompany='监测点总数';
          this.getCustomerListA.forEach((item,index)=>{
            item.selTrue = 0;
            item.children.forEach((item1,index)=>{
              if(obi==item1.id){
                item1.selTrue = 1;
              }else{
                item1.selTrue = 0;
              }
              
            })
          })
          this.isMouseIcon=false;
          this.showMap = 2
          sessionStorage.setItem('customerId',obi)
          this.$nextTick(()=>{
            // 获取子组件方法
            this.$refs.mapHome.getpointMap()
          })
          this.$store.state.bigScreenBuildingId=obi;
        }else{
          this.isSchoolCompany='单位总数';
          this.getCustomerListA.forEach((item,index)=>{
            item.selTrue = 1;
            item.children.forEach((item1,index)=>{
                item1.selTrue = 0;
            })
          })
          this.showMap = 1
          this.$store.state.bigScreenBuildingId='';
        }
        this.getBigScreenData(this.$store.state.bigScreenBuildingId);
        this.dialogVisible=false;
        if(this.socketNoticid!=obi){
          this.socketNoticClose = 2
          this.socketNotic.close();
          // this.websockeInit(obi);//连接websocket
        }
        this.socketNoticid = obi;//保存当前ID
      },
        // 心跳
       timeoutnumSuccF(){
         var that = this;
          that.timeoutnumSucc && clearTimeout(that.timeoutnumSucc);
          that.timeoutnumSucc1 && clearTimeout(that.timeoutnumSucc1);
          that.timeoutnumSucc = setTimeout(function () {
            // console.log('测试')
            if (that.socketNotic.readyState===1) {
              that.socketNotic.send("monitorReconnection");
            }else{
                //do something
            }
            that.timeoutnumSucc1 = setTimeout(function () {
              // console.log('关闭')
              that.socketNotic.close();
            },10000);
          },1200000);
       },
       websockeInit(obj){
          var webSocketUrl = SocketUrl() 
          let token = sessionStorage.getItem('token')
          const wsuri = webSocketUrl + '/superviseIndex/totalOverview?customerId='+ obj+'&token='+token;//ws地址    
          if(token){
            this.socketNotic = new WebSocket(wsuri); 
            this.socketNotic.onopen = this.websocketonopen;
            this.socketNotic.onerror = this.websocketonerror;
            this.socketNotic.onmessage = this.websocketonmessage; 
            this.socketNotic.onclose = this.websocketclose;
          }
    　　},
    　　websocketonopen() {
          // console.log("通知列表连接成功");
          this.socketNoticClose = 1;//连接成功他就等于1
          this.timeoutnumSuccF()

    　　},
        //错误
    　　websocketonerror(e) {
          // console.log("通知列表连接发生错误");
    　　},
        //数据接收 
    　　websocketonmessage(e){
          // console.log(e.data)
          // console.log(e)
          if(e.data =="connectSuccess"){
            this.timeoutnumSuccF()
          }else{
      　　　 const res = JSON.parse(e.data);
            this.topTotalInfo= res;
            // 获取子组件方法
            this.$refs.mapLeft.watchWebsocket()
            this.$refs.mapRight.watchWebsocket()
            this.getAlarmList();

          }
    　　}, 
        //数据发送 
    　　websocketsend(agentData){
            // this.websock.send(agentData); 
    　　}, 
        //关闭
    　　websocketclose(e){ 

            // console.log("通知列表连接断开11 (" + e.code + ")"); 

            if(this.socketNoticClose == 2)return;
            var that = this;
            if(that.lockReconnect) {
                return;
            };
            that.lockReconnect = true;
            //没连接上会一直重连，设置延迟避免请求过多
            that.timeoutnum && clearTimeout(that.timeoutnum);
            that.timeoutnum = setTimeout(function () {
                //新连接
                // that.websockeInit(that.socketNoticid);//连接websocket  
                that.lockReconnect = false;
            },10000);



    　　},

      //获取建筑id
      getBuildingId(val){
        if(val!==0){
            let params = {
              customerId: this.showType[val].id,
              buildingId: '',
              target: '0'
            };
            ajaxFuncJson('/basicData/getMonitorByCustomerId',params).then(res=>{
              sessionStorage.setItem('pointData',JSON.stringify(res.data.data));
              this.$store.dispatch('getRightPoint',res.data.data);
            });
          this.$store.state.bigScreenBuildingId=this.showType[val].id;
        }else {
          this.$store.state.bigScreenBuildingId='';
        }
        this.getBigScreenData(this.$store.state.bigScreenBuildingId);
      },

      //获取当前的时间
      getNowTime(){
        this.clearTime=setTimeout( ()=> {
          let timeObj=new Date(),hour,minute,second;
          hour=timeObj.getHours();
          minute=timeObj.getMinutes();
          second=timeObj.getSeconds();
          if(timeObj.getHours()<10){
            hour='0'+timeObj.getHours();
          }
          if(timeObj.getMinutes()<10){
            minute='0'+timeObj.getMinutes();
          }
          if(timeObj.getSeconds()<10){
            second='0'+timeObj.getSeconds();
          }
          this.nowTime = timeObj.getFullYear()+'年'+(timeObj.getMonth()+1)+'月'+timeObj.getDate()+'日'+' '+hour+':'+minute+':'+second;
          this.getNowTime();
        },1000);
      },
      //获取大屏首页顶部统计数据
      getBigScreenData(data){
        let params={
          customerId:data,
        };
        ajaxFuncJson('/superviseIndex/totalOverview',params).then(res=>{
          if(res.data.status==200){
            this.topTotalInfo=res.data.data;
          }else {
            this.$message({
              type:'error',
              message: res.data.msg,
            })
          }
        })
      },
      //获取地图上面的点标记经纬度
      getMapPosition(){
        ajaxFuncJson('/superviseIndex/getCustomerList','').then(res=>{
          if(res.data.status==200){
              let markers=[];
              res.data.data.forEach((item,index)=>{
                let json={
                  // icon:'../../../static/img/school.png',
                  icon:'../../../static/img/1.gif',
                  position:[item.longitude,item.latitude],
                  customerName:item.customerName,
                  id:item.id,
                  userName:item.userName,
                  userPhone:item.userPhone,
                  imageSize: new AMap.Size(26,26)
                };
                if(item.longitude&&item.latitude){
                  markers.push(json);
                  this.$set(item,'type',2);
                  this.showType.push(item);
                }
              });
              // console.log(this.showType)
              this.setMapIcon(markers);
          }else {
            this.$message({
              type:'error',
              message:res.data.msg,
            })
          }
        });
      },
      //设置点标记
      setMapIcon(markers){
        map.clearMap();  // 清除地图覆盖物
        markers.forEach((marker,index)=>{
            var markerIcon=new AMap.Marker({
              map: map,
              icon: marker.icon,
              title:'',
              mapid:marker.id,
              label:{
                offset: new AMap.Pixel(0, 5),  //设置文本标注偏移量
                content: "<div class='info' data-id="+marker.id+">"+marker.customerName+"</div>", //设置文本标注内容
                direction: 'bottom' //设置文本标注方位
              },
              position: [marker.position[0],marker.position[1]],
              offset: new AMap.Pixel(-13, -30)
            });
            markerIcon.content= '';
            // markerIcon.on('mouseover',this.markerClick);
            markerIcon.on('mouseover',this.getSchoolDeviceInfo);
            markerIcon.on('mouseout',this.closeWindowInfo);
            markerIcon.on('click',this.clickInfo);
            // markerIcon.emit('mouseover',{target:markerIcon});   //默认不显示

        });
        map.setFitView();
        // marker.setMap(map);
      },
      // 点击建筑
      clickInfo(e){
        // console.log(e.target.Je.mapid)
        this.isSchoolCompany='监测点总数';

        this.isMouseIcon=false;
        this.showMap = 2
        sessionStorage.setItem('customerId',e.target.Je.mapid)
        this.$nextTick(()=>{
          // 获取子组件方法
          this.$refs.mapHome.getpointMap()
        })
        this.$store.state.bigScreenBuildingId=e.target.Je.mapid;
          this.getBigScreenData(this.$store.state.bigScreenBuildingId);
          this.socketNoticClose = 2;
          this.socketNotic.close();
          // this.websockeInit(e.target.Je.mapid);//连接websocket

        this.socketNoticid = e.target.Je.mapid;//保存当前ID

      },
      //移入获取校企机构列表的信息
      getSchoolDeviceInfo(e){
        e.target.setIcon('../../../static/img/schoolactive.png');
        this.tipData  = [];
        let id=e.target.getLabel().content.substring((e.target.getLabel().content.indexOf('data-id')+8),e.target.getLabel().content.indexOf('>'));
        // console.log(id)
        let params={
          customerId: id,
        };
        this.showType.map((infoItem,infoIndex)=>{
          if(infoItem.type!==1){
            if(infoItem.id==id){
              this.tipHeadInfo={    //头部信息
                schoolName:infoItem.customerName,
                userName: infoItem.userName,
                userPhone: infoItem.userPhone,
              };
            }
          }
        });
        ajaxFuncJson('/superviseIndex/monitorGroupByType',params).then(res=>{
            if(res.data.status===200){
              
              this.schoolDeviceInfo=res.data.data;
              this.isMouseIcon=true;
              this.tipLeft=e.pixel.x;
              this.tipTop=e.pixel.y+100;
              if(e.pixel.y+330>this.bodyHeight){
                this.tipTop=e.pixel.y-130;
              }
              if(e.pixel.x+360>this.bodyWidth){
                this.tipLeft=e.pixel.x-360;
              }
              
              this.getMapTipData();
              
            }else {
              this.$message({
                type:'error',
                message:res.data.msg,
              })
            }
        })
      },

      //创建信息窗口
      markerClick(e) {
        // console.log(e);
        this.infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(0, -30)});
        this.infoWindow.setContent(e.target.content);
        this.infoWindow.open(map, e.target.getPosition());
      },
      //移出关闭信息窗口
      closeWindowInfo(e){
        // e.target.setIcon('../../../static/img/school.png');
        e.target.setIcon('../../../static/img/1.gif');
        this.isMouseIcon=false;
      },
      //获取设备的数据进行处理
      dealInfoType(item,key){
        let json={
          deviceType:'',
          deviceInfo:item.replace(/;/g, '、'),
        };
        
        if(item.indexOf('安全')!==-1){   //0  正常  1告警  2预警  3故障  4离线
          json.deviceType=0;
        }else if(item.indexOf('告警')!==-1){
          json.deviceType=1;
        }else if(item.indexOf('预警')!==-1){
          json.deviceType=2;
        }else if(item.indexOf('故障')!==-1){
          json.deviceType=3;
        }else if(item.indexOf('离线')!==-1){
          json.deviceType=4;
        }else if(item.indexOf('暂无设备')!==-1){
          json.deviceType=5;
        }
        // this.$set(vm.items, indexOfItem, newValue)
        this.tipData[key].typeName.push(json);
      },
      textSize(fontSize,fontFamily,text){
        var span = document.createElement("span");
        var result = {};
        result.width = span.offsetWidth;
        result.height = span.offsetHeight;
        span.style.visibility = "hidden";
        span.style.fontSize = fontSize;
        span.style.fontFamily = fontFamily;
        span.style.display = "inline-block";
        document.body.appendChild(span);
        if(typeof span.textContent != "undefined"){
          span.textContent = text;
        }else{
          span.innerText = text;
        }
        result.width = parseFloat(window.getComputedStyle(span).width) - result.width;
        result.height = parseFloat(window.getComputedStyle(span).height) - result.height;
        return result;
      },

      getMapTipData(){
        let _this=this;
        this.tipData = [{
          type:'1',
          typeName:[],   //alarmNames
          typeNumber:this.schoolDeviceInfo.electric.alarmRatio,
        },{
          type:'2',
          typeName:[],
          typeNumber:this.schoolDeviceInfo.water.alarmRatio,
        },{
          type:'3',
          typeName:[],
          typeNumber:this.schoolDeviceInfo.liquid.alarmRatio,
        },{
          type:'4',
          typeName:[],
          typeNumber:this.schoolDeviceInfo.gas.alarmRatio,
        },{
          type:'5',
          typeName:[],
          typeNumber:this.schoolDeviceInfo.somke.alarmRatio,
        },{
          type:'6',
          typeName:[],
          typeNumber:this.schoolDeviceInfo.fire.alarmRatio,
        }];
        this.dealInfoType(this.schoolDeviceInfo.electric.alarmNames,0);
        this.dealInfoType(this.schoolDeviceInfo.water.alarmNames,1);
        this.dealInfoType(this.schoolDeviceInfo.liquid.alarmNames,2);
        this.dealInfoType(this.schoolDeviceInfo.gas.alarmNames,3);
        this.dealInfoType(this.schoolDeviceInfo.somke.alarmNames,4);
        this.dealInfoType(this.schoolDeviceInfo.fire.alarmNames,5);
        
        
        this.tipData.forEach((item,index)=>{  
            item.typeName[0].deviceInfoSize =  this.textSize("13px","Arial",item.typeName[0].deviceInfo) 


        })

        this.tipData.forEach((item,index)=>{  
            item.typeName[0].deviceInfoSize =  this.textSize("13px","Arial",item.typeName[0].deviceInfo) 
          // console.log(item.typeName[0].deviceInfoSize.width);
            
        })
          // console.log(this.tipData);
        
        
        // _this.$nextTick(()=>{
        //   $('.info_type').find('.swiper-container').each((index,item)=>{
        //     _this['swiperLider'+index].params.loop=false;
        //     if(item.scrollWidth>item.clientWidth){
        //       _this['swiperLider'+index].params.loop=true;
        //     }
        //   });
        //   _this.swiperLider0.init();
        //   _this.swiperLider1.init();
        //   _this.swiperLider2.init();
        //   _this.swiperLider3.init();
        //   _this.swiperLider4.init();
        //   _this.swiperLider5.init();
        // })
      },

    },
    destroyed(){
      let _this=this;
      window.removeEventListener("resize",_this.windowResize);
      clearTimeout(this.clearTime);
    },

  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  @import "@/assets/css/style.scss";
  @font-face {
    font-family: unidreamLED;
    src: url("../../assets/iconfont/UnidreamLed.ttf");
    /* IE9+  HTML节点的lang="en" 记得去掉，不然会谷歌浏览器会自动翻译导致字体不正确 */
  }



 

  .right_route{
    position: relative;
    height:36px;
  }
  .disabledNone{
    display: none;
  }
  .right_info{
    min-width: 130px;
    height:144px;
    border: 1px solid #264480;
    position: absolute;
    bottom: 8%;
    right: 400px;
    z-index: 1;
    .right_route>.right_crumbs{
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin: 10px 10px 10px 10px;

    }
    .right_route>span:nth-of-type(2){
      line-height: 36px;
      font-size: 13px !important;
      color: #e0e0e0;
      display: inline-block;
      position: absolute;
      // top: 8px;
      left: 36px;
    }
  }
  .dialogTop{
    line-height: 50px;
    color: #0f6ade;
    border-bottom: 1px solid #294282;
    cursor: pointer;

  }
  .dialogSel{
    color:#00fcc9 !important;
  }
  .dialogTop_li{
    li{
      line-height: 50px;
      color: #66b3ff;
      border-bottom: 1px solid #294282;
      text-indent: 16px;
      cursor: pointer;
    }
    
  }
  .Divbadge{
    background-color: #ff0000;
    border-radius: 10px;
    color: #FFFFFF;
    display: inline-block;
    font-size: 12px;
    height: 6px;
    line-height: 6px;
    padding: 0 3px;
    text-align: center;
    white-space: nowrap;
    margin-left: 5px;
    position: relative;
    top: -8px;
  }
  .list_dialog .el-dialog {
      background: rgba(44, 40, 84, 0.8);
  }
  .mainHead{
    width: 100%;
    background: #fff;
    height:57px;
    border-bottom: 1px solid #efefef;
    margin: 10px 0;
    position: relative;
    .route{
      height:100%;
    }
    .route>.crumbs{
      display: inline-block;
      width: 6px;
      height: 16px;
      background: #198cff;
      // margin: 19px 10px;
      position: absolute;
      top: 20px;
      left: 10px;

    }
    .route>span:nth-of-type(2){
      line-height: 56px;
      font-size: 14px;
      color: #666666;
      font-weight: bold;
      display: inline-block;
      position: absolute;
      top: 0;
      left: 24px;
    }
    .btnsW{
      position: absolute;
      top: 10px;
      right:20px;
    }

  }
  .switchBtn{
    @include wh(80px,30px);
    margin-top: 3px;
    text-align: center;
    line-height: 30px;
    outline: 1px solid #e0e0e0;
    outline-offset: -1px;
    position: absolute;
    top: 10px;
    right:200px;
    cursor: pointer;
    color:#666;
  }
  .switchBtn:hover{
    outline: 1px solid #2280ff;
    color:#2280ff;
  }
  .btns {
      li {
          float: left;
          @include wh(80px,30px);
          margin-top: 3px;
          text-align: center;
          line-height: 30px;
          font-size: $fontSizeTwo;
          outline: 1px solid #e0e0e0;
          outline-offset: -1px;
          cursor:pointer;
          &:nth-child(2):hover {
              color: #198cff;
              outline: 1px solid #198cff;
              cursor: pointer;
          }
          &:nth-child(1):hover {
              background-color: #3399ff;
          }
      }
      .btn_select1 {
          color: #fff;
          background-color: #198cff;
          outline: none;
      }
  }
  .dot_tip{
    width: 380px;
    height: 290px;
    position: fixed;
    border: 1px solid #264480;
    margin: 0 auto;
    z-index: 3;
    background:rgba(0,0,0,.5);
    color: #fff;
    .name_type{
      font-size: 14px;
      font-weight: bold;
      color: #00b0ff;
      line-height: 35px;
      padding-left: 20px;
      background: rgba(44,40,84,.4);
      position: relative;
      .person_info{
        position: absolute;
        right: 20px;
        font-weight: normal;
        color: #26c0c0;
        font-size: 13px;
      }
    }
    .normal_item{
      height: 42.5px;
      .info_item{
        display: flex;
        height: 100%;
        align-items: center;
        padding: 0 20px;
        font-size: 13px;
        color: #fff;
        position: relative;
        .icon_size{
          display: inline-block;
          width: 100px;
          .icon_name{
            position: relative;
            top:-4px;
          }
          .icon_type{
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
        .item_name{
          color: #26c0c0;
          display: inline-block;
          width: 80px;
        }
        .info_type{
          display: inline-block;
          width: 140px;
          position: relative;
          top:3px;
          white-space: nowrap;
           overflow: hidden;
        }
      }
    }
  }



  #mapIndex{
    width: 100%;
    height: 100%;
    position: relative;
    .screen_container{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top:140px;
      .swiper-container{
        width: 100%;
        height: 100%;
      }
    }
    #map_container{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
    #map_container1{
      width: 100%;
      height: 100%;
      /*position: absolute;*/
      /*left: 0;*/
      /*top: 0;*/
      /*z-index: 1;*/
    }
    .title{
      font-size: 30px;
      font-weight: bold;
      position: relative;
      line-height: 50px;
      width: 520px;
      margin: 0 auto;
      padding-top: 40px;
      padding-bottom: 60px;
      z-index: 2;
      text-align: center;
      .title_info{
        display: inline-block;
        width: 100%;
        border: 1px solid #233D71;
        background-image:-webkit-linear-gradient(bottom,#0077ff,#59a6ff);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
      }
      .now_time{
        position: fixed;
        top: 150px;
        right: 20px;
        color:#28C2C1;
        font-size: 20px;
        font-weight: normal;
        border: 1px solid #233D71;
        line-height: 32px;
        padding: 0 10px;
      }
    }
    .center_container{
      margin: 0 auto;
      position: relative;
      z-index: 2;
      display: flex;
      .list_item{
        padding-top: 12px;
        height: 100px;
        text-align: center;
        color:#28C2C1;
        background-color:rgba(44,40,84,.4);
        border: 1px solid #264480;
        font-family: unidreamLED;
        font-size:36px;
        :first-child{
          padding-bottom: 17px;
          font-size: 16px;
          color: #00b0ff;
        }
      }
    }
    .left_content{
      position: absolute;
      width: 360px;
      left: 20px;
      top:150px;
      bottom: 10px;
      // overflow-y: auto;
      z-index: 2;
      
    }
    

        .left_content::-webkit-scrollbar
    {
        width: 4px;
        height: 4px;
        background-color: #F5F5F5;
    }
    
    /*定义滚动条轨道 内阴影+圆角*/
    .left_content::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 10px;
        background-color: #F5F5F5;
    }
    
    /*定义滑块 内阴影+圆角*/
    .left_content::-webkit-scrollbar-thumb
    {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #465177;
    }


    .right_content{
      position: absolute;
      width: 360px;
      right: 20px;
      top:150px;
      z-index: 2;
      // bottom: 10px;
      // overflow-y: auto;
    }
    .right_content::-webkit-scrollbar
    {
        width: 4px;
        height: 4px;
        background-color: #F5F5F5;
    }
    
    /*定义滚动条轨道 内阴影+圆角*/
    .right_content::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 10px;
        background-color: #F5F5F5;
    }
    
    /*定义滑块 内阴影+圆角*/
    .right_content::-webkit-scrollbar-thumb
    {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #465177;
    }



  }
</style>




// WEBPACK FOOTER //
// src/page/mapIndexHome/index.vue